import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

const messages = {
  'en-US': {
    ...enLocale,
    ...elementEnLocale
  },
  'zh-CN': {
    ...zhLocale,
    ...elementZhLocale
  }
}
export function getLanguage () {
  const chooseLanguage = localStorage.getItem('language') || ''
  if (chooseLanguage) return chooseLanguage
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  localStorage.setItem('language', 'zh-CN')
  return 'zh-CN'
}
const i18n = new VueI18n({
  locale: getLanguage() || 'zh-CN',
  messages
})
export default i18n



// WEBPACK FOOTER //
// ./src/lang/index.js